<!--
 * @Author:
 * @LastEditTime: 2022-04-18 19:56:27
 * @Description: 重置密码
-->
<template>
  <div>
    <el-dialog
      width="600px"
      v-dialogDrag
      :append-to-body="true"
      :visible.sync="resetPasswordProps.visible"
      title="重置密码"
      class="mini-dialog"
    >
      <el-form
        label-width="150px"
        :rules="resetPasswordRules"
        ref="resetPasswordForm"
        :model="resetPasswordForm"
      >
        <el-form-item label="用户密码" prop="password">
          <el-input v-model="resetPasswordForm.password" type="password" size="small" clearable />
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input
            v-model="resetPasswordForm.confirmPassword"
            type="password"
            size="small"
            clearable
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="text-center">
        <el-button size="small" type="primary" class="iconfont icon-save" @click="save()"
          >保存</el-button
        >
        <el-button size="small" class="iconfont icon-close" @click="cancel()">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import UserService from '@/services/oidcLoginService/User'
import { UserApi } from '@wiz-api/abp-identity'

const userApi = new UserApi()

export default {
  name: 'resetPasswordDialog',
  props: {
    resetPasswordProps: {
      type: Object,
      default: () => {
        return {
          visible: true,
          title: '重置密码',
        }
      },
    },
    resetPasswordForm: {
      type: Object,
      default: () => {
        return {
          password: '',
          confirmPassword: '',
        }
      },
    },
  },
  watch: {
    'resetPasswordProps.visible': {
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            this.$refs.resetPasswordForm.clearValidate()
          })
        }
      },
    },
  },
  data() {
    const validataPassword = (rule, value, callback) => {
      if (/^(?=.*[A-Za-z])(?=.*\d)[\s\S]{6,}$/.test(value) === false) {
        callback(new Error('密码至少6位，且包含数字、大小写字母'))
        return
      }
      callback()
    }
    const validateConfirmPassword = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('请再次输入密码'))
      }
      if (value !== this.resetPasswordForm.password) {
        return callback(new Error('两次输入密码不一致!'))
      }
      return callback()
    }
    return {
      resetPasswordRules: {
        password: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur',
          },
          {
            validator: validataPassword,
            trigger: 'blur',
          },
        ],
        confirmPassword: [
          {
            validator: validateConfirmPassword,
            trigger: 'blur',
          },
        ],
      },
    }
  },
  methods: {
    cancel() {
      this.resetPasswordProps.visible = false
    },
    save() {
      this.$refs.resetPasswordForm.validate(async (valid) => {
        if (valid) {
          // const resetPasswordRes = await UserService.updateUsers(this.resetPasswordForm)
          const [err] = await userApi.update(this.resetPasswordForm.id, {
            body: this.resetPasswordForm,
          })
          if (!err) {
            this.resetPasswordProps.visible = false
            this.$message.success('重置密码成功')
          }
        }
      })
    },
  },
}
</script>
